import { c as _c } from "react-compiler-runtime";
import { useEffect, useState } from 'react';
import Raven from 'raven-js';
export const useFindPopoverAnchorElement = t0 => {
  const $ = _c(14);
  const {
    callToAction,
    scrollContainerElementRef,
    widths
  } = t0;
  const [anchorElement, setAnchorElement] = useState(null);
  const [isAnchorVisible, setIsAnchorVisible] = useState(true);
  let t1;
  if ($[0] !== callToAction || $[1] !== scrollContainerElementRef) {
    t1 = () => {
      const startedAt = Date.now();
      let nextDelayMs = 0;
      let timeoutId;
      const attempt = () => {
        const scrollContainer = scrollContainerElementRef.current;
        if (!callToAction || !scrollContainer) {
          setAnchorElement(null);
          return;
        }
        const found = scrollContainer.querySelector(`[data-column-index="${callToAction.columnIndex}"][data-fdt-row-index="${callToAction.rowIndex}"]`);
        if (found) {
          setAnchorElement(found);
          return;
        }
        if (Date.now() - startedAt >= 10000) {
          Raven.captureException(new Error("FrameworkDataTable columnCallToAction: could not find target cell within 10s"), {
            extra: {
              columnIndex: callToAction.columnIndex,
              rowIndex: callToAction.rowIndex
            }
          });
          setAnchorElement(null);
          return;
        }
        nextDelayMs = nextDelayMs === 0 ? 50 : Math.min(nextDelayMs * 2, 1000);
        timeoutId = setTimeout(attempt, nextDelayMs);
      };
      timeoutId = setTimeout(attempt, 0);
      return () => clearTimeout(timeoutId);
    };
    $[0] = callToAction;
    $[1] = scrollContainerElementRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== callToAction || $[4] !== scrollContainerElementRef || $[5] !== widths) {
    t2 = [callToAction, widths, scrollContainerElementRef];
    $[3] = callToAction;
    $[4] = scrollContainerElementRef;
    $[5] = widths;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[7] !== anchorElement || $[8] !== scrollContainerElementRef) {
    t3 = () => {
      const scrollRoot = scrollContainerElementRef.current;
      if (!anchorElement || !scrollRoot) {
        return;
      }
      const observer = new IntersectionObserver(t5 => {
        const [entry] = t5;
        return setIsAnchorVisible(entry.isIntersecting);
      }, {
        root: scrollRoot,
        threshold: 0
      });
      observer.observe(anchorElement);
      return () => observer.disconnect();
    };
    t4 = [anchorElement, scrollContainerElementRef];
    $[7] = anchorElement;
    $[8] = scrollContainerElementRef;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] !== anchorElement || $[12] !== isAnchorVisible) {
    t5 = {
      anchorElement,
      isAnchorVisible
    };
    $[11] = anchorElement;
    $[12] = isAnchorVisible;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};